var styleDataHash = "02d3086b";
const injectCss = (() => {
  var css = `.-smup{background:rgba(0,0,0,.5);height:100%;position:relative;width:100%}.QvC4T{animation:NMVVD 1.7s ease infinite,YihLy 1.7s ease infinite;border-radius:50%;bottom:0;color:#fbfbfb;font-size:60px;height:1em;left:0;margin:auto;position:absolute;right:0;top:0;width:1em}.QvC4T._1E2-2{font-size:40px}.QvC4T.H87HC{font-size:20px}.r9Vun{border-radius:50%;bottom:0;color:#fbfbfb;font-size:60px;height:1.5em;left:0;margin:auto;position:absolute;right:0;text-align:center;top:0;width:3em}.r9Vun._1E2-2{font-size:16px}.r9Vun.H87HC{font-size:12px}.MQr7M{height:100%;width:100%}@keyframes YihLy{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes NMVVD{0%{box-shadow:0 -.83em 0 -.4em,0 -.83em 0 -.42em,0 -.83em 0 -.44em,0 -.83em 0 -.46em,0 -.83em 0 -.477em}5%,95%{box-shadow:0 -.83em 0 -.4em,0 -.83em 0 -.42em,0 -.83em 0 -.44em,0 -.83em 0 -.46em,0 -.83em 0 -.477em}10%,59%{box-shadow:0 -.83em 0 -.4em,-.087em -.825em 0 -.42em,-.173em -.812em 0 -.44em,-.256em -.789em 0 -.46em,-.297em -.775em 0 -.477em}20%{box-shadow:0 -.83em 0 -.4em,-.338em -.758em 0 -.42em,-.555em -.617em 0 -.44em,-.671em -.488em 0 -.46em,-.749em -.34em 0 -.477em}38%{box-shadow:0 -.83em 0 -.4em,-.377em -.74em 0 -.42em,-.645em -.522em 0 -.44em,-.775em -.297em 0 -.46em,-.82em -.09em 0 -.477em}to{box-shadow:0 -.83em 0 -.4em,0 -.83em 0 -.42em,0 -.83em 0 -.44em,0 -.83em 0 -.46em,0 -.83em 0 -.477em}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var loaders_default = {
  "loaderOverlay": "-smup",
  "loader": "QvC4T",
  "load6": "NMVVD",
  "spinner": "YihLy",
  "medium": "_1E2-2",
  "mini": "H87HC",
  "progress": "r9Vun",
  "preview_img": "MQr7M"
};
export {
  loaders_default as default,
  injectCss
};
//# sourceMappingURL=loaders-scss.js.map
